import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-mall-company-pay",
  "use": "icon-soc-mall-company-pay-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-mall-company-pay\">\n<g fill=\"currentColor\">\n  <rect x=\"180\" y=\"280\" width=\"664\" height=\"464\" rx=\"48\" />\n  <rect x=\"180\" y=\"280\" width=\"664\" height=\"120\" rx=\"48\" />\n  <circle cx=\"320\" cy=\"560\" r=\"56\" fill=\"#fff\" />\n  <rect x=\"420\" y=\"520\" width=\"320\" height=\"32\" rx=\"8\" fill=\"#fff\" />\n  <rect x=\"420\" y=\"580\" width=\"220\" height=\"24\" rx=\"8\" fill=\"#fff\" />\n  <path d=\"M512 160c80 0 120 72 120 72H392s40-72 120-72z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-mall-company-pay.svg
// module id = 6Ba2
// module chunks = 491